import { useRef, useEffect } from "react";

import { Button } from "@newsela/angelou";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import ErrorIcon from "@/icons/ErrorIcon";
import {
  rootCss,
  buttonCss,
  iconCss,
  textCss,
} from "./QuizWarningMessage.style";

const propTypes = {
  /**
   * An array of objects representing the questions skipped or missed by the user
   */
  skippedQuestions: PropTypes.arrayOf(PropTypes.object),
  /**
   * The content id (not level-specific) of the current quiz
   */
  quizId: PropTypes.string,
};

const defaultProps = {
  skippedQuestions: [],
};

const QuizWarningMessage = ({ skippedQuestions, quizId }) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    if (buttonRef?.current) {
      buttonRef.current.focus();
    }
  }, []);

  const router = useRouter();
  const { pathname, query } = router;

  const createHref = (question) => {
    return {
      pathname,
      query: {
        ...query,
        activity: "quiz",
        quizId,
        question: question?.position,
      },
    };
  };

  const handleClick = (question) => {
    router.replace(createHref(question), null, { shallow: true });
  };

  if (skippedQuestions.length === 0) {
    return null;
  }

  return (
    <div css={rootCss} role="alert">
      <div>
        <ErrorIcon css={iconCss} aria-hidden="true" />
      </div>
      <p css={textCss}>
        {"You skipped "}
        {skippedQuestions.map((question, index) => {
          const buttonLabel = `Question ${question.position}`;
          return (
            <span key={question.position}>
              {!!index && skippedQuestions.length > 2 ? ", " : null}
              {index === skippedQuestions.length - 1 &&
              skippedQuestions.length > 1
                ? " and "
                : null}
              <Button
                __cssFor={{ root: buttonCss }}
                flavor={Button.flavors.incognito}
                onClick={() => handleClick(question)}
                ref={index === 0 ? buttonRef : null}
                key={`question-${question.position}`}
              >
                {buttonLabel}
              </Button>
            </span>
          );
        })}
      </p>
    </div>
  );
};

QuizWarningMessage.propTypes = propTypes;
QuizWarningMessage.defaultProps = defaultProps;

export default QuizWarningMessage;
